import { motion } from "framer-motion";
import { Check } from "lucide-react";

import { LinkButton, SectionHeader } from "./ui";

const tiers = [
  {
    name: "ROOKIE",
    price: "0",
    period: "/ MO",
    features: ["Basic Ticker", "Basic Integrations", "Community Support"],
    cta: "START FREE",
    href: "/sign-in?mode=register",
    popular: false,
    badge: undefined as string | undefined,
  },
  {
    name: "PRO",
    price: "2.99",
    period: "/ MO",
    features: ["Complete Ticker", "iRacing Integration", "SimRacerHub Integration", "Priority Support"],
    cta: "GET PRO",
    href: "/sign-in?mode=register&plan=pro_monthly",
    popular: true,
    badge: undefined as string | undefined,
  },
  {
    name: "YEARLY",
    price: "24.99",
    period: "/ YR",
    features: ["Everything in PRO", "Save 30%"],
    cta: "GO YEARLY",
    href: "/sign-in?mode=register&plan=pro_yearly",
    popular: false,
    badge: "BEST VALUE",
  },
];

export function Pricing() {
  return (
    <section id="pricing" className="border-t border-border bg-surface/30 py-24">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeader eyebrow="Pricing" title="Choose Your Plan" align="center" />

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-3">
          {tiers.map((tier, index) => (
            <motion.div
              key={tier.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className={`relative flex flex-col rounded-xl border bg-surface p-8 ${
                tier.popular ? "border-primary/60 shadow-[0_0_0_1px_var(--primary)]" : "border-border"
              }`}
            >
              {tier.popular ? (
                <>
                  <div className="absolute left-6 right-6 top-0 h-px bg-primary" />
                  <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-md bg-primary px-3 py-1 text-[10px] font-bold tracking-[0.25em] text-text">
                    POPULAR
                  </div>
                </>
              ) : null}
              {tier.badge && !tier.popular ? (
                <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-md border border-border bg-surface-2 px-3 py-1 text-[10px] font-bold tracking-[0.25em] text-muted">
                  {tier.badge}
                </div>
              ) : null}

              <h3 className="mb-6 font-display text-xl font-bold uppercase tracking-[0.2em] text-text">{tier.name}</h3>

              <div className="mb-8 flex items-start">
                <span className="mt-2 font-display text-2xl text-muted">$</span>
                <span className="font-display text-6xl font-bold leading-none tracking-tight text-text md:text-7xl">
                  {tier.price}
                </span>
                <span className="mb-2 ml-1 mt-auto text-xs font-semibold tracking-[0.2em] text-muted">{tier.period}</span>
              </div>

              <ul className="mb-8 flex-1 space-y-3">
                {tier.features.map((feature) => (
                  <li key={feature} className="flex items-center gap-3 text-sm text-text">
                    <Check size={16} className="shrink-0 text-primary" />
                    {feature}
                  </li>
                ))}
              </ul>

              <LinkButton href={tier.href} variant={tier.popular ? "primary" : "ghost"} className="w-full">
                {tier.cta}
              </LinkButton>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
